import { render, staticRenderFns } from "./product-support.vue?vue&type=template&id=3d85ed01"
import script from "./product-support.vue?vue&type=script&lang=js"
export * from "./product-support.vue?vue&type=script&lang=js"
import style0 from "./product-support.vue?vue&type=style&index=0&id=3d85ed01&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports